import { defineComponent as _defineComponent } from 'vue'

import { computed, defineComponent, useRoute, useStore } from "@nuxtjs/composition-api";

import { getLtksStore } from "@/store/ltks";
import { getSharedWishlistsStore } from "@/store/shared-wishlists";
import { getWishlistsStore } from "@/store/wishlists";

const __default__ = defineComponent({ name: "WishCollectionItem" });

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  wishId: {
    type: String,
    required: true,
  },
  showDiscount: {
    type: Boolean,
    default: false,
  },
  showShopNow: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props;



const store = useStore();
const route = useRoute();

const wish = computed(() => {
  if (route.value.name === "collections-hash") {
    return getSharedWishlistsStore(store).sharedWishItems[props.wishId];
  }
  return getWishlistsStore(store).wishes[props.wishId];
});

const ltk = computed(() => {
  const ltksStore = getLtksStore(store);

  return ltksStore.ltks[wish.value?.ltkId ?? ""];
});
const profileId = computed(() => ltk.value?.profileId || "");

return { __sfc: true,props, store, route, wish, ltk, profileId }
}

})